import { AfterViewInit, Component } from '@angular/core';
import { GmapLogService } from 'app/services';
import { BASE_URL } from 'app/utils';

declare var google: any;
declare var $: any;

@Component({
  selector: 'geo-fence',
  templateUrl: 'geo-fence.html'
})
export class GeoFence implements AfterViewInit {

  constructor(private gmapLogService: GmapLogService){}
  

  ngAfterViewInit(): void {
    var map = new google.maps.Map(document.getElementById('map'), {
      center: {
        lat: 37.512340,
        lng: 127.025086
      },
      zoom: 3
    });

    this.gmapLogService.log('geo-fence', 'MAP');

    var drawingManager = new google.maps.drawing.DrawingManager(
      {
        drawingMode: google.maps.drawing.OverlayType.MARKER,
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: ['polygon', 'polyline']
        },

        polygonOptions: {
          strokeColor: '#000000',
          strokeOpacity: 0.8,
          strokeWeight: 1,
          fillColor: '#000000',
          fillOpacity: 0.35,
          editable: true,
          draggable: true,
        },

        polylineOptions: {
          strokeColor: '#000000',
          strokeOpacity: 0.8,
          strokeWeight: 1,
          fillColor: '#000000',
          fillOpacity: 0.35,
          editable: true,
          draggable: true,
        }
      });

    drawingManager.setMap(map);

    var markerArrays = [];
    var markerDataArrays = [];
    var polygonArrays = [];
    var polygonDataArrays = [];
    var polylineArrays = [];
    var polylineDataArrays = [];

    $.getJSON(BASE_URL + 'findAll', function (data) {
      data.data.forEach(function (deplocation, idx, val) {
        $('#depPort').append($('<option data-lat=' + deplocation.latitude + ' data-lng=' + deplocation.longitude + '></option>').text(deplocation.cntryCd + '-' + deplocation.name + '-' + deplocation.locationId).val(deplocation.locationId));
      });
    });

    $('#depPort').on('change', function (event) {
      $.getJSON(BASE_URL + 'findByDepLocationId?depLocationId=' + $(this).val(), function (data) {
        $('#arrPort option').not(':first').remove();
        data.data.forEach(function (arrlocation, idx, val) {
          $('#arrPort').append($('<option data-lat=' + arrlocation.latitude + ' data-lng=' + arrlocation.longitude + '></option>').text(arrlocation.cntryCd + '-' + arrlocation.name + '-' + arrlocation.locationId).val(arrlocation.locationId));
        });
      });
      $('#depBtn').val($(this).val());
    });

    $('#arrPort').on('change', function (event) {
      var selArrPort = $(this).val();
      $('#arrBtn').val(selArrPort);
    });

    $('#search').on('click', function (event) {

      initMarker();
      initPolyline();
      initPolygon();
      currentPolygonIdCnt = 0;

      var $depPort = $("#depPort option:selected");
      var $arrPort = $("#arrPort option:selected");

      var depLatLng = { lat: parseFloat($depPort.data('lat')), lng: parseFloat($depPort.data('lng')) };
      var depMarker = new google.maps.Marker({
        position: depLatLng,
        map: drawingManager.getMap(),
        title: $arrPort.text()
      });
      markerArrays.push(depMarker);

      var arrLatLng = { lat: parseFloat($arrPort.data('lat')), lng: parseFloat($arrPort.data('lng')) };
      var arrMarker = new google.maps.Marker({
        position: arrLatLng,
        map: drawingManager.getMap(),
        title: $arrPort.text()
      });

      markerArrays.push(arrMarker);

      drawingManager.getMap().panTo(depMarker.getPosition());

      var selDepPort = $depPort.val();
      var selArrPort = $arrPort.val();

      var queryStr = 'depPortLocationId=' + selDepPort + '&arrPortLocationId=' + selArrPort;

      $.getJSON(BASE_URL + "findDraw?" + queryStr, function (data) {

        if (!$(data.data).length) {
          alert('저장된 경로가 존재 하지 않습니다.');
          return false;
        }
        if (data.data[0].latLngArrays) {
          var polylineArr = [];

          JSON.parse(data.data[0].latLngArrays).forEach(function (latlng, idx, val) {
            polylineArr.push(JSON.parse(latlng));
          });

          var polyline = new google.maps.Polyline({
            path: polylineArr,
            geodesic: true,
            strokeColor: '#FF0000',
            strokeOpacity: 1.0,
            strokeWeight: 1,
            editable: true,
            draggable: true,
          });

          polyline.setMap(drawingManager.getMap());
          polylineAddListener(polyline);
        }


        var selDepPort = $("#depPort option:selected").val();
        var selArrPort = $("#arrPort option:selected").val();

        var makeDepPolygon = function (depTeminalPolygonMap) {
          JSON.parse(depTeminalPolygonMap).forEach(function (ploygon, idx, val) {

            var polygonArr = []

            JSON.parse(ploygon).forEach(function (latlng, idx, val) {
              polygonArr.push(JSON.parse(latlng));
            });

            var polygon = new google.maps.Polygon({
              paths: polygonArr,
              strokeColor: '#cec64a',
              strokeOpacity: 0.8,
              strokeWeight: 1,
              fillColor: '#cec64a',
              fillOpacity: 0.35,
              editable: true,
              draggable: true,
            });

            polygon.setMap(drawingManager.getMap());
            polygonAddListener(polygon, selDepPort);
          });
        }

        var makeArrPolygon = function (arrTeminalPolygonMap) {
          if (!arrTeminalPolygonMap) {
            return;
          }
          
          JSON.parse(arrTeminalPolygonMap).forEach(function (ploygon, idx, val) {

            var polygonArr = []

            JSON.parse(ploygon).forEach(function (latlng, idx, val) {
              polygonArr.push(JSON.parse(latlng));
            });

            var polygon = new google.maps.Polygon({
              paths: polygonArr,
              strokeColor: '#00B0EF',
              strokeOpacity: 0.8,
              strokeWeight: 1,
              fillColor: '#00B0EF',
              fillOpacity: 0.35,
              editable: true,
              draggable: true,
            });

            polygon.setMap(drawingManager.getMap());
            polygonAddListener(polygon, selArrPort);
          });
        }

        var depPortPolgonArea = data.data[0].toolDepPortPolgonArea;
        var arrPortPolgonArea = data.data[0].toolArrPortPolgonArea;

        if (depPortPolgonArea) {
          if (depPortPolgonArea.locationId + '' === selDepPort) {
            makeDepPolygon(depPortPolgonArea.teminalPolygonMap);
          } else {
            makeArrPolygon(depPortPolgonArea.teminalPolygonMap);
          }
        }

        if (arrPortPolgonArea) {
          if (arrPortPolgonArea.locationId + '' === selArrPort) {
            makeArrPolygon(arrPortPolgonArea.teminalPolygonMap);
          } else {
            makeDepPolygon(arrPortPolgonArea.teminalPolygonMap);
          }
        }
      });
    });

    $('#save').on('click', function () {

      var selDepPort = $("#depPort option:selected").val();
      var selArrPort = $("#arrPort option:selected").val();

      if (!polylineDataArrays.length) {
        alert('폴리라인 정보를 입력해주세요.');
        return false;
      }

      var depDrawFlag = false, appDrawFlag = false;

      polygonDataArrays.forEach(function (polygonData, idx, val) {
        if (polygonData.locationId === selDepPort) {
          depDrawFlag = true;
        }
      });

      if (!depDrawFlag) {
        alert('출발지 폴리라인 정보를 입력해주세요.');
        return false;
      }

      polygonDataArrays.forEach(function (polygonData, idx, val) {
        if (polygonData.locationId === selArrPort) {
          appDrawFlag = true;
        }
      });

      if (!appDrawFlag) {
        alert('도착지 폴리라인 정보를 입력해주세요.');
        return false;
      }

      var selVal = $("#fn option:selected").val();


      var polygonDataParams = [];

      var depPolygonDataParam = {
        locationId: '',
        teminalPolygonMap: []
      };
      var ArrPolygonDataParam = {
        locationId: '',
        teminalPolygonMap: []
      };

      polygonDataArrays.forEach(function (polygonData, idx, val) {
        if (polygonData.locationId === selDepPort) {
          depPolygonDataParam.locationId = polygonData.locationId;
          depPolygonDataParam.teminalPolygonMap.push(JSON.stringify(polygonData.currentPolygonData));

        } else {
          ArrPolygonDataParam.locationId = polygonData.locationId;
          ArrPolygonDataParam.teminalPolygonMap.push(JSON.stringify(polygonData.currentPolygonData));
        }
      });

      depPolygonDataParam.teminalPolygonMap.push(JSON.stringify(depPolygonDataParam.teminalPolygonMap));
      ArrPolygonDataParam.teminalPolygonMap.push(JSON.stringify(ArrPolygonDataParam.teminalPolygonMap));

      polygonDataParams.push(depPolygonDataParam);
      polygonDataParams.push(ArrPolygonDataParam);

      var latLngArrays = JSON.stringify(polylineDataArrays[0].currentPolylineData);

      var pushObject = {
        arrPortLocationId: selArrPort,
        depPortLocationId: selDepPort,
        latLngArrays: latLngArrays,
        googleMapDrawSaveParam: polygonDataParams,
      };

      $.ajax({
        url: BASE_URL + "saveDraw",
        type: "POST",
        data: JSON.stringify(pushObject),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (data) {
          alert('저장 성공');
        }
      });

    });

    var removeFn = function (ele, idx, val) {
      ele.setMap(null);
    }

    var initMarker = function () {
      markerArrays.forEach(removeFn);
      markerDataArrays = [];
    }

    var initPolyline = function () {
      polylineArrays.forEach(removeFn);
      polylineDataArrays = [];
    }

    var initPolygon = function () {
      polygonArrays.forEach(removeFn);
      polygonDataArrays = [];
    }

    $('#reset').on('click', function () {
      var selVal = $("#fn option:selected").val();

      switch (selVal) {

        case "marker":

          initMarker();
          break;

        case "polyline":

          initPolyline();
          break;

        case "polygon":

          initPolygon();
          break;

        default:

          initMarker();
          initPolyline();
          initPolygon();
          break;
      }
    });

    google.maps.event.addListener(drawingManager,
      'markercomplete', function (marker) {
        google.maps.event.addListener(marker, 'dragend', function (event) {
        });

        markerArrays.push(marker);
        markerDataArrays.push(marker.getPosition().toJSON());
      });

    var currentPolygonIdCnt = 0, currentPolygon = null;

    var polygonAddListener = function (polygon, callParam?) {

      var PolylinePath = polygon.getPath();
      currentPolygon = polygon;
      var a = new Date();
      var currentPolygonId = currentPolygonIdCnt++;
      polygon.uuid = currentPolygonId;
      polygonArrays.push(polygon);

      var locationId = $('input[name=chk_info]:checked').val();
      var polygonData = {
        id: currentPolygonId,
        locationId: callParam || locationId,
        currentPolygonData: []
      };

      var polygonPath = polygon.getPath();

      google.maps.event.addListener(polygon, 'click', function (event) {
        polygonArrays.forEach(function (polygonHis, idx, val) {
          if (polygonHis.uuid == polygon.uuid) {
            console.log(polygonHis.uuid);
            currentPolygon = polygonArrays[idx];
          }
        })
      });

      google.maps.event.addListener(polygon, 'dragend', function (event) {
        polygonDataArrays.forEach(function (polygonData, idx, val) {
          if (polygonData.id === currentPolygonId) {
            polygonData.currentPolygonData = [];
            polygonPath.getArray().forEach(function (ele, idx, val) {
              polygonData.currentPolygonData.push(JSON.stringify(ele.toJSON()));
            });
          }
        });
      });

      google.maps.event.addListener(polygonPath, 'set_at', function (event) {
        polygonDataArrays.forEach(function (polygonData, idx, val) {
          if (polygonData.id === currentPolygonId) {
            polygonData.currentPolygonData = [];
            polygonPath.getArray().forEach(function (ele, idx, val) {
              polygonData.currentPolygonData.push(JSON.stringify(ele.toJSON()));
            });
          }
        });
      });

      google.maps.event.addListener(polygonPath, 'insert_at', function (event) {
        polygonDataArrays.forEach(function (polygonData, idx, val) {
          if (polygonData.id === currentPolygonId) {
            polygonData.currentPolygonData = [];
            polygonPath.getArray().forEach(function (ele, idx, val) {
              polygonData.currentPolygonData.push(JSON.stringify(ele.toJSON()));
            });
          }
        });
      });

      polygonPath.getArray().forEach(function (ele, idx, val) {
        polygonData.currentPolygonData.push(JSON.stringify(ele.toJSON()));
      });

      polygonDataArrays.push(polygonData);
    }

    var currentPolylineCnt = 0, currentPolyline = null;

    var polylineAddListener = function (polyline) {

      var polylinePath = polyline.getPath();
      currentPolyline = polyline;
      var currentPolylineId = currentPolylineCnt++;
      polylineArrays.push(polyline);

      var polylineData = {
        id: currentPolylineId,
        currentPolylineData: []
      };

      google.maps.event.addListener(polyline, 'click', function (event) {

      });

      google.maps.event.addListener(polylinePath, 'set_at', function (event) {
        polylineDataArrays.forEach(function (polylineData, idx, val) {
          if (polylineData.id === currentPolylineId) {
            polylineData.currentPolylineData = [];
            polylinePath.getArray().forEach(function (ele, idx, val) {
              polylineData.currentPolylineData.push(JSON.stringify(ele.toJSON()));
            });
          }
        });
      });

      google.maps.event.addListener(polylinePath, 'insert_at', function (event) {
        polylineDataArrays.forEach(function (polylineData, idx, val) {
          if (polylineData.id === currentPolylineId) {
            polylineData.currentPolylineData = [];
            polylinePath.getArray().forEach(function (ele, idx, val) {
              polylineData.currentPolylineData.push(JSON.stringify(ele.toJSON()));
            });
          }
        });
      });

      polylinePath.getArray().forEach(function (ele, idx, val) {
        polylineData.currentPolylineData.push(JSON.stringify(ele.toJSON()));
      });

      polylineDataArrays.push(polylineData);
    }

    google.maps.event.addListener(drawingManager,
      'polygoncomplete', function (polygon) {
        polygonAddListener(polygon);
      });

    google.maps.event.addListener(drawingManager,
      'polylinecomplete', function (polyline) {
        polylineAddListener(polyline);
      });

    google.maps.event.addDomListener(document, 'keyup', function (e) {
      var code = (e.keyCode ? e.keyCode : e.which);
      if (code === 46) {
        drawingManager.setDrawingMode(null);
        polygonDataArrays.splice(currentPolygon.uuid, 1);
        currentPolygon.setMap(null);
      }
    });

    var polylineArr = [];
    $(document).bind('copy', function () {
      polylineArr = [];
      polylineDataArrays.forEach(function (polylineData, idx, val) {
        polylineData.currentPolylineData.forEach(function (ele, idx, val) {
          polylineArr.push(JSON.parse(ele));
        });
      });
    });

    $(document).bind('paste', function () {
      if (polylineDataArrays.length) {
        alert('폴리라인은 1개 이상 그릴 수 없습니다.');
      }

      if (polylineArr.length) {
        var polyline = new google.maps.Polyline({
          path: polylineArr,
          geodesic: true,
          strokeColor: '#FF0000',
          strokeOpacity: 1.0,
          strokeWeight: 1,
          editable: true,
          draggable: true,
        });

        polyline.setMap(drawingManager.getMap());
        polylineAddListener(polyline);
        console.log("paste");
      } else {
        alert('복사 된 폴리라인 정보가 존재 하지 않습니다.');
      }
    });



  }
  
}


// WEBPACK FOOTER //
// ./src/app/containers/geo-fence/geo-fence.ts